import { ReactNode } from 'react';

import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from './render-extension';

export interface ResourceLinkOptions {
  name: string;
  text: ReactNode;
  className?: string;
}

export const ResourceLinkExtensions = createItemRenderExtensions<
  ItemRenderExtensionOptions<ResourceLinkOptions>
>({
  id: 'resource-link',
});

export const createResourceLinkExtension = (
  options: ItemRenderExtensionOptions<ResourceLinkOptions>,
) => {
  return createItemRenderExtension<
    ItemRenderExtensionOptions<ResourceLinkOptions>
  >(options);
};

export const useResourceLinkExtensions = () => {
  return useItemRenderExtensions<
    ItemRenderExtensionOptions<ResourceLinkOptions>
  >(ResourceLinkExtensions);
};
